module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"messages for me":"Messages for me"},"de":{"messages for me":"Nachrichten für mich"}}')
  delete Component.options._Ctor
}
